import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VentayaComponent } from './component/ventaya/ventaya.component';

const routes: Routes = [
  { path: 'ventaya', component: VentayaComponent },
  { path: '', redirectTo: 'venta-ya', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class VentayaRoutingModule {}